import React from 'react';
import { useSelector } from 'react-redux';
import { theme, Table } from 'antd';
import { RootState } from 'store/configureStore';
import { INestedTableProps } from 'store/ducks/Global/types';
import * as Styled from './NestedTable.styled';

const { useToken } = theme;

const NestedTable: React.FC<INestedTableProps> = ({ dataSource, ...rest }) => {
  const { token } = useToken();
  const { drawTable, scheme } = useSelector((state: RootState) => ({
    drawTable: state.complianceEst.drawTable,
    scheme: state.global.scheme
  }));

  return (
    <Styled.TableWrapper
      token={token}
      scheme={scheme}
      className='nested-table-wrapper'
    >
      <Table dataSource={dataSource} pagination={false} {...rest} />
    </Styled.TableWrapper>
  );
};

export default NestedTable;
